<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 5</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Informatie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Achter alle huizen van Bloemendaal zijn er ‘brandweggetjes’. Handig voor bewoners die met de fiets de tuin in willen. Maar ook voor chirospelletjes. Het bekendste spelletje is ‘straat in straat uit’. Wist je dat zelfs chirogroepen uit andere wijken naar Bloemendaal komen om in ‘onze’ brandwegen het spel te spelen.                
                </p>
                <p class="text-center d-block margin">
                    Weet jij hoe dat gaat? Leg het dan even uit aan je meewandelaars. Heb je het al gespeeld? Dan heb je daar zeker leuke herinneringen aan, want het is al jààààren een topper op het chiroprogramma.                 
                </p>
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Loop hier de brandweg in en neem de eerste afslag naar links. Sla vervolgens schuin rechtsaf. Dan kom je op het Latyrusplein.             
            </p>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte6'">Volgende stop</button>
    </div>
</div>